import React, { FC } from 'react';

import { Container } from './PageWrapper.styled';

interface PageWrapperProps {
  children: React.ReactNode;
}

export const PageWrapper: FC<PageWrapperProps> = ({ children }) => (
  <Container>{children}</Container>
);
